//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import handleErrorMixin from '@/mixins/handleErrorMixin'
import HeaderStepSkills from './HeaderStepSkills.vue'
import ValidationSkillsSection from './ValidationSkillsSection.vue'
import CollaboratorCount from './CollaboratorCount.vue'
import ValidationSkills from './ValidationSkills.vue'
import ModalValidationConfirmation from './ModalValidationConfirmation.vue'
import Notification from './Notification.vue'
import Button from '~/components/Shared/Button.vue'
import ValidationContainer from '~/components/Validation/ValidationContainer.vue'
import ASSIGMENT_VALIDATION_STATUS from '~/constants/assigment-validation-status.js'

export default {
  components: {
    Button,
    ValidationContainer,
    HeaderStepSkills,
    ValidationSkillsSection,
    CollaboratorCount,
    ValidationSkills,
    ModalValidationConfirmation,
    Notification,
  },
  mixins: [handleErrorMixin],
  props: {
    projectId: {
      type: Number,
      required: true,
    },
    projectRoleId: {
      type: Number,
      required: true,
    },
    showNotificationChanges: {
      type: Boolean,
      default: false,
    },
    assignments: {
      type: Array,
      default: () => [],
    },
  },
  async fetch() {
    this.setProgressValidationIndex()
    await this.setValidationSkills(
      this.assignments[this.progressValidationIndex].id
    )
  },
  data() {
    return {
      isExpanded: false,
      progressValidationIndex: 0,
      validationSkills: [],
      isVisibleModalConfirmation: false,
    }
  },
  computed: {
    userSkillsHas() {
      return this.validationSkills.filter((skill) => skill.user_has_skill)
    },
    userSkillsNotHas() {
      return this.validationSkills.filter((skill) => !skill.user_has_skill)
    },
    currentAssignment() {
      return this.assignments[this.progressValidationIndex]
    },
    disabledNextButton() {
      return (
        this.validationSkills.some(
          (skill) => skill.supervisor_validate_skill == null
        ) || this.validationSkills.length === 0
      )
    },
    userId() {
      return this.$strapi.user.id
    },
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    toogleModalConfirmation() {
      this.isVisibleModalConfirmation = !this.isVisibleModalConfirmation
    },
    resize() {
      this.isExpanded = window.innerWidth <= 435
    },
    setProgressValidationIndex() {
      this.progressValidationIndex = this.assignments.filter((assigment) =>
        [ASSIGMENT_VALIDATION_STATUS.FINISHED].includes(
          assigment.validation_status
        )
      ).length
    },
    async setValidationSkills(assigmentId) {
      this.validationSkills = []
      this.validationSkills = await this.getValidationSkills(assigmentId)
    },
    async getValidationSkills(assigmentId) {
      try {
        this.$store.commit('loading', true)
        return await this.$repository.skillsValidations.findToAssignmentId(
          assigmentId
        )
      } catch (error) {
        this.handleErrorMixin.handleError(
          error,
          'Ocurrió un error al cargar las habilidades de validación'
        )
      } finally {
        this.$store.commit('loading', false)
      }
    },
    handleUpdateSkill(skill) {
      this.validationSkills = this.validationSkills.map((sk) => {
        if (sk.id === skill.id) {
          return {
            ...sk,
            supervisor_validate_skill: skill.supervisor_validate_skill,
            collaborator_has_skill: skill.user_has_skill,
          }
        }
        return sk
      })
      this.updateAssigmentStatus()
      this.$emit('saving', false)
    },
    handleSaving(value) {
      this.$emit('saving', value)
    },

    async updateAssigmentStatus() {
      if (
        this.currentAssignment.validation_status ===
        ASSIGMENT_VALIDATION_STATUS.PENDING
      ) {
        await this.$repository.supervisorAssignments.updateStatus(
          this.currentAssignment.id,
          ASSIGMENT_VALIDATION_STATUS.IN_PROGRESS
        )
      }
    },
    async handleNext() {
      try {
        this.$store.commit('loading', true)
        if (this.progressValidationIndex === this.assignments.length - 1) {
          this.toogleModalConfirmation()
        } else {
          await this.updateValidationStatus()
          this.progressValidationIndex = this.progressValidationIndex + 1
          this.setValidationSkills(
            this.assignments[this.progressValidationIndex].id
          )
        }
      } catch (error) {
        this.handleError(error, 'Ocurrió un error')
      } finally {
        this.$store.commit('loading', false)
      }
    },
    handlePrevious() {
      if (this.progressValidationIndex > 0) {
        this.progressValidationIndex = this.progressValidationIndex - 1
        this.setValidationSkills(
          this.assignments[this.progressValidationIndex].id
        )
      }
    },
    async handleConfirmValidation() {
      try {
        this.$store.commit('loading', true)
        await this.updateValidationStatus()
        this.$emit('next')
      } catch (error) {
        this.handleError(error, 'Ocurrió un error al confirmar la validación')
      } finally {
        this.$store.commit('loading', false)
        this.toogleModalConfirmation()
      }
    },
    async updateValidationStatus() {
      await this.$repository.supervisorAssignments.updateStatus(
        this.assignments[this.progressValidationIndex].id,
        ASSIGMENT_VALIDATION_STATUS.FINISHED
      )
      await this.$repository.projectRoles.updateValidationStatus(
        this.projectId,
        this.userId
      )
      await this.$repository.supervisorAssignments.matchSupervisorAssignment(
        this.assignments[this.progressValidationIndex].id
      )
    },
  },
}
